<template>
  <div id="main" class="main-content">
    <router-view />
    <footer class="my-3">
       <hr />
      <div class="text-end">
        &copy; {{ new Date().getFullYear() }} GroupTrips. All Rights Reserved
      </div>
      <div class="clear"></div>
    </footer>
  </div>
</template>

<script></script>

<style>
@import "~bootstrap/dist/css/bootstrap.css";

@font-face {
  font-family: "robotoregular";
  src: url("./assets/roboto-regular-webfont.eot");
  src: url("./assets/roboto-regular-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("./assets/roboto-regular-webfont.woff") format("woff"),
    url("./assets/roboto-regular-webfont.ttf") format("truetype"),
    url("./assets/roboto-regular-webfont.svg#robotoregular") format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "robotobold";
  src: url("./assets/roboto-bold-webfont.eot");
  src: url("./assets/roboto-bold-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("./assets/roboto-bold-webfont.woff") format("woff"),
    url("./assets/roboto-bold-webfont.ttf") format("truetype"),
    url("./assets/roboto-bold-webfont.svg#robotobold") format("svg");
  font-weight: normal;
  font-style: normal;
}

html {
}

body {
  font-family: "robotoregular", Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #3b4760;
  background: #eef4ff;
  overflow-x: hidden;
}

ol {
  counter-reset: list;
  list-style-type: none;
  display: table;
  padding-left: 5px;
}

ol > li {
  counter-increment: list;
  display: table-row;
}

ol > li:before {
  content: counter(list) ")\00a0\00a0\00a0";
  display: table-cell;
  text-align: right;
}

.main-content {
  width: 100%;
  margin: 0px;
  padding: 2px 10px;
}

@media (min-width: 960px) {
  .main-content {
    width: 960px;
    margin: 0px auto;
    padding: 0px;
  }
}

h1 {
  font-family: "robotobold", Arial, Helvetica, sans-serif;
  font-size: 30px;
  font-weight: normal;
  margin-bottom: 10px;
  color: #5478c2;
}

h2 {
  font-family: "robotobold", Arial, Helvetica, sans-serif;
  font-size: 22px;
  font-weight: normal;
  margin-bottom: 10px;
  color: #4468b2;
}

h3 {
  font-family: "robotobold", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 6px;
  color: #4468b2;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.white-box-1 {
  background: #fff;
  padding: 15px 20px;
  border-bottom: 1px solid #dbe1eb;
  border-radius: 6px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 24px;
}

   .field-error {
      background-color: pink
   }
</style>
